// extracted by mini-css-extract-plugin
export default {"subtitle":"Commissions_subtitle__CKFT0","statusBubble":"Commissions_statusBubble__70GQA","statusContainer":"Commissions_statusContainer__++E38"};